import { useQuery } from "react-query"
import { useParams } from "react-router-dom"
import API from "../../../services/API"

export default function usePack(){

    const { reference } = useParams()

    return useQuery({

        queryKey: ['pack', reference],

        queryFn: () => API.get(`/products/packs/${reference}`)
            .then(r => r.data) 
    })

}